module.exports = __webpack_public_path__ + "img/flag-BO.6059212f.png";